import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';

type MutationVariables = {
  inviteIds: string[];
  studentIds: string[];
};

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useAddSelectedStudentsToClass = (classId: string, organizationId: string, callbacks?: Callbacks) => {
  const queryClient = useQueryClient();
  const classesService = useServices().classesService;
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: ({ inviteIds, studentIds }: MutationVariables) => classesService.addSelectedStudentsToClass(classId, inviteIds, studentIds),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['organizationInvites', organizationId] }),
        queryClient.invalidateQueries({ queryKey: ['organizationStudents', organizationId] }),
      ]);
      notificationsStore.addToast('success', i18next.t('AddedStudentsToSelectedClass', { ns: 'classPage' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('AddingStudentsToClassError', { ns: 'classPage' }), 'error'),
  });
};
